import { render } from "./CustomTextarea.vue?vue&type=template&id=08c2a8eb&scoped=true"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"

import "./CustomTextarea.vue?vue&type=style&index=0&id=08c2a8eb&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c2a8eb"]])

export default __exports__